import React, { useState } from "react";
import { AiOutlineFileExcel } from "react-icons/ai";
import {
  FaDesktop,
  FaMobileAlt,
  FaAndroid,
  FaUserTie,
  FaShoppingCart,
  FaGlobe,
} from "react-icons/fa";
import { TagComponent } from "../Tabs";

const ExcelImport = () => {
  const [activeTab2, setActiveTab2] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow-md"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">
      {/* Panel Header */}


      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <AiOutlineFileExcel className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Excel Import & Print Order Settings</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-2xl ">
        <p className="text-gray-700 text-start text-base leading-relaxed ">
          You can arrange the product attributes as needed by dragging and
          dropping the 'Serial No.' badge to set their sequence.
        </p>
      </div>

      <div className="my-5">
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">
          <img
            src=""
            alt={`view`}
            className="rounded-xl max-w-full h-auto object-contain"
          />
        </div>
      </div>

      <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start">
        Reordering attributes will update your Excel template for importing
        data. Each time you change the attribute order, make sure to download a
        new Excel template. You can get the latest template in the 'Products'
        section by clicking the 'Download Template' button.
      </div>
    </div>
  );
};

export default ExcelImport;
